import useCustomHook from '@/hooks/useCustomHook';
import { shuffleList } from '@/modules/gameUtils/random';
import { useEffect } from 'react';

export default function useDragPage({ page, cloudFolder, activityActions }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      images: [],
      texts: [],
      answers: [],
      draggedOptionId: null,
    },
    actions: {
      onDragStart: ({ active }) => {
        actions.setState({
          draggedOptionId: active.id,
        });
      },
      onDragEnd: ({ active, over }) => {
        let stateChanges = {
          draggedOptionId: null,
        };
        if (over) {
          const answers = state.answers.filter(
            (answer) =>
              !(answer.answerId == over.id) && !(answer.id == active.id)
          );
          const answer = {
            id: active.id,
            correct: active.id == over.id,
            answerId: over.id,
            pageId: page.id,
          };
          answers.push(answer);
          stateChanges = {
            ...stateChanges,
            answers,
            answered: answers.length === state.images.length,
            correct: answers.every((a) => a.correct),
          };
          if (stateChanges.answered) {
            activityActions.onActivityProgress(page.id, answers);
          }
        }
        actions.setState({
          ...stateChanges,
        });
      },
    },
  });

  useEffect(() => {
    if (page.data) {
      const images = shuffleList(
        page.data.options.map((option) => ({
          id: option.id,
          imgSrc: `${cloudFolder}/${
            option.img || `imgs/${page.id}-${option.id}.webp`
          }`,
          text: option.text,
        }))
      );
      const texts = shuffleList(page.data.options);

      actions.setState({
        images,
        texts,
      });
    }
  }, [page.data]);

  return { state, actions };
}
